import React from 'react';
import { FormStack, FormStackProps } from '@tw/tw-component-library';
import { CustomTextDisplay } from '../../../common/CustomTextDisplay';

interface FormStackWrapperProps extends FormStackProps {
  sectionKey?: string;
  permissionsErrorMessage?: string | null;
  rejectionMessage?: React.ReactNode;
  cancellationMessage?: string | null;
  paymentHoldReviewMessage?: string | null;
}

export const FormStackWrapper: React.FC<FormStackWrapperProps> = ({
  errors,
  sectionKey,
  permissionsErrorMessage,
  rejectionMessage,
  cancellationMessage,
  paymentHoldReviewMessage,
  ...formStackProps
}) => {
  return (
    <div data-section={sectionKey}>
      {/* Cancellation Banner */}
      {cancellationMessage && (
        <CustomTextDisplay
          text={`Form Cancelled: ${cancellationMessage}`}
          showIcon
          variant="error"
          weight="normal"
          margin="0 0 1.5rem 0"
          data-testid="cancellation-banner"
        />
      )}

      {/* Rejection Banner */}
      {rejectionMessage && !cancellationMessage && (
        <CustomTextDisplay
          text={rejectionMessage}
          showIcon
          variant="error"
          weight="normal"
          margin="0 0 1.5rem 0"
          data-testid="rejection-banner"
        />
      )}

      {/* Permissions Error Banner */}
      {permissionsErrorMessage && !rejectionMessage && !cancellationMessage && (
        <CustomTextDisplay
          text={`Access Restricted: ${permissionsErrorMessage}`}
          showIcon
          variant="warning"
          weight="normal"
          margin="0 0 1.5rem 0"
          data-testid="permissions-error-banner"
        />
      )}

      {/* Payment Hold Review Banner */}
      {paymentHoldReviewMessage &&
        !rejectionMessage &&
        !cancellationMessage &&
        (sectionKey === 'first_partner' || sectionKey === 'second_partner') && (
          <CustomTextDisplay
            text={`Payment Hold Review: ${paymentHoldReviewMessage}`}
            showIcon
            variant="info"
            weight="normal"
            margin="0 0 1.5rem 0"
            customStyles={{ whiteSpace: 'pre-line' }}
            data-testid="payment-hold-review-banner"
          />
        )}

      <FormStack
        {...formStackProps}
        errors={errors}
        enableAutoFocusNext={false}
      />
    </div>
  );
};
